/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CallWithAuth } from '../../../action/apiActions';
import {
  GET_AUTHOR,
  GET_FREE_TAG,
  GET_PRODUCT,
  GET_QUESTIONBANK,
  GET_TEST_TYPE_LIST,
  TEST_ID_SEARCH,
} from '../../../action/apiPath';
import style from '../../../assets/styles/modalStyle.module.css';
import { Get_Product_Type } from '../../../redux/action';
import NativeButton from '../Button';
import closeIcon from '../../../assets/images/closeSvgIcon.svg';
import { useToast } from '../../molecule/common/Toast';
const TestFilterModal = ({
  onFilterStateChange,
  closeModalFilter,
  setFiltersApplied,
  multiselectedAuthorTag,
  setMultiselectedAuthorTag,
  multiselectedFreeTag,
  setmultiSelectedFreeTag,
  selectedId,
  setSelectedId,
  selecteStatus,
  setSelecteStatus,
  selectQuestionBank,
  setSelectQuestionBank,
  selecetdPlayer,
  setSelectedPlayer,
  testType,
  setTestType,
  selectedYearExclude,
  setSelectedYearExclude,
  selectedYear,
  setSelectedYear,
}) => {
  // _________ AUTHIR TAG STATE INITIALIZATION _________
  const [multiAuthorTaginput, setmultiAuthorTaginput] = useState('');
  const [multiAuthorTag, setmultiAuthorTag] = useState([]);
  const [multiAuthorTagStatus, setmultiAuthorTagStatus] = useState(false);
  // CALL GET API FOR getting TAGS
  const [onMouseHover, setOnMouseHover] = useState(false);

  const TagAuthorMultiple = async (e) => {
    setmultiAuthorTaginput(e);
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_AUTHOR + organizationId + '/?keyword=' + e);
      if (data.status && data.res.status === 200) {
        setmultiAuthorTag(data.res.data);
        if (data.res.data.length > 0) {
          setmultiAuthorTagStatus(true);
        } else {
          setmultiAuthorTagStatus(false);
        }
      }
    } else {
      setmultiAuthorTagStatus(false);
    }
  };

  // select tags from options
  const selectAuthorTag = (e) => {
    setMultiselectedAuthorTag((current) => [...current, e]);
    setmultiAuthorTagStatus(false);
    setmultiAuthorTaginput('');
  };

  // _________ PRIMARY TAG STATE INITIALIZATION _________

  // _________ Free TAG STATE INITIALIZATION _________
  const [multiFreeTaginput, setmultiFreeTaginput] = useState('');
  const [multiFreeTag, setmultiFreeTag] = useState([]);
  const [multiFreeTagStatus, setmultiFreeTagStatus] = useState(false);

  // CALL GET API FOR getting TAGS
  const TagFreeMultiple = async (e) => {
    setmultiFreeTaginput(e);
    if (e.length > 2) {
      const data = await CallWithAuth('GET', GET_FREE_TAG + '?keyword=' + e);
      if (data.status && data.res.status === 200) {
        setmultiFreeTag(data.res.data);
        if (data.res.data.length > 0) {
          setmultiFreeTagStatus(true);
        } else {
          setmultiFreeTagStatus(false);
        }
      }
    } else {
      setmultiFreeTagStatus(false);
    }
  };

  // select tags from options
  const selectFreeTag = (e) => {
    setmultiSelectedFreeTag((current) => [...current, e]);
    setmultiFreeTagStatus(false);
    setmultiFreeTaginput('');
  };

  // __________________ outside clickable close modal _____________________

  const { getTestCreationData } = useSelector((state) => state.GetAllData);
  const toast = useToast();
  /** ____________ Filter for id ________ */
  const [searchId, setSearchId] = useState('');
  const [matchingIds, setMatchingIds] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const handleSearchInput = async (value) => {
    if (isNaN(value)) {
      setSearchId('');
      return;
    }
    if (value === '') {
      setMatchingIds([]);
      setIsDropdownVisible(false);
      setSearchId('');
      return;
    }
    const input = value;
    setSearchId(input);

    // Check if input is empty or not a number
    if (!input || isNaN(parseInt(input, 10))) {
      setMatchingIds([]);
      setIsDropdownVisible(false);
      return;
    }
    let url = TEST_ID_SEARCH(organizationId, input);

    const result = await CallWithAuth('GET', url);
    if (result.status && result?.res && result?.res?.status === 200) {
      setIsDropdownVisible(true);
      setMatchingIds(result.res.data);
      toast.remove('all');
    } else {
      setMatchingIds([]);
      setIsDropdownVisible(false);
      toast.remove('all');
      toast.add('Test ID not found', 'error');
    }
  };

  const removeId = (itemToRemove) => {
    setSelectedId((current) => current.filter((item) => item !== itemToRemove));
  };
  const removeTestTemplate = (itemToRemove) => {
    setSelectedPlayer((current) => current.filter((item) => item.product_type !== itemToRemove.product_type));
  };
  const removeStatus = (itemToRemove) => {
    setSelecteStatus((current) => current.filter((item) => item !== itemToRemove));
  };
  const removeAuthor = (itemToRemove) => {
    setMultiselectedAuthorTag((current) => current.filter((item) => item.id !== itemToRemove.id));
  };
  const removeFreeTags = (itemToRemove) => {
    setmultiSelectedFreeTag((current) => current.filter((item) => item.name !== itemToRemove.name));
  };
  const handleSelectId = (id) => {
    // Check if the ID is already selected to prevent duplicates
    if (!selectedId.includes(id)) {
      setSelectedId((prevIds) => [...prevIds, id]);
    }

    setSearchId('');
    setMatchingIds([]);
    setIsDropdownVisible(false);
  };
  // ____________________________________________________________________________//
  // Create an array of years from 2000 to 20 years after the current year
  const yearOptions = [];
  const currentYear = new Date().getFullYear();
  for (let year = 2000; year <= currentYear + 20; year++) {
    yearOptions.push(year);
  }
  // GET QUESTION BANK API CALL SAVED THE DATA IN STATE
  const [questionBank, setQuestionBank] = useState([]);
  const organizationId = localStorage.getItem('selectedOrgId');

  const getQuestionBank = async () => {
    const GetData = await CallWithAuth('GET', GET_QUESTIONBANK + organizationId + '/?permission=true');
    if (GetData.status && GetData?.res?.data && Array.isArray(GetData.res.data)) {
      setQuestionBank(GetData?.res?.data);
    }
  };

  // ____________________________ Filter for status ________________//

  const [filteredStatus, setFilteredStatus] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [filterDropdown, setFilterDropdown] = useState(false);

  const filterStatus = (input) => {
    const lowerCaseInput = input.toLowerCase();
    const filtered = getTestCreationData?.results?.filter((name) =>
      name?.status?.toLowerCase().startsWith(lowerCaseInput)
    );

    const nameOptions = filtered?.map((obj) => obj?.status);

    const uniqueNames = [...new Set(nameOptions)];
    setFilteredStatus(uniqueNames);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (value.length > 1) {
      filterStatus(value);
      setFilterDropdown(true);
    } else {
      setFilteredStatus([]);
      setFilterDropdown(false);
    }
  };

  const handleSelectionChange = (name) => {
    const data = Array.from(new Set([...selecteStatus, name].map((item) => JSON.stringify(item)))).map((str) =>
      JSON.parse(str)
    );
    setSelecteStatus(data);
    setInputValue('');
    setFilterDropdown(false);
  };

  // ____________________________ Filter for template ________________//
  const dispatch = useDispatch();
  const { getProductType } = useSelector((state) => state.GetAllData);
  useEffect(() => {
    dispatch(Get_Product_Type());
  }, [dispatch]);

  useEffect(() => {
    getTemplate();
  }, []);
  const [player, setPlayer] = useState([]);
  const [playerInput, setPlayerInput] = useState('');
  const [templateList, setTemplateList] = useState([]);
  const [playerDropdown, setPlayerDropdwon] = useState(false);
  const getTemplate = async (id) => {
    const data = await CallWithAuth('GET', GET_PRODUCT + '?test_type=0');
    if (data.status && data.res.status === 200) {
      setTemplateList(data.res.data);
    }
  };
  const playerStatus = (input) => {
    const lowerCaseInput = input.toLowerCase();
    const authored = templateList?.filter((name) => name?.product_type?.toLowerCase().startsWith(lowerCaseInput));

    const nameOptions = authored?.map((player) => ({
      id: player.id,
      product_type: player.product_type,
    }));

    const uniquePlayers = [...new Set(nameOptions.map((player) => player.id))];
    setPlayer(uniquePlayers.map((id) => nameOptions.find((player) => player.id === id)));
  };

  const handlePlayerInputChange = (event) => {
    const value = event.target.value;
    setPlayerInput(value);

    if (value.length > 1) {
      playerStatus(value);
      setPlayerDropdwon(true);
    } else {
      setPlayer([]);
      setPlayerDropdwon(false);
    }
  };

  const handlePlayerChange = (player) => {
    const data = Array.from(new Set([...selecetdPlayer, player].map((item) => JSON.stringify(item)))).map((str) =>
      JSON.parse(str)
    );
    setSelectedPlayer(data);
    setPlayerInput('');
    setPlayerDropdwon(false);
  };

  // ____________________________________________________________________________//

  const handle = () => {
    onFilterStateChange(
      multiselectedAuthorTag,
      multiselectedFreeTag,
      selectedId,
      selecteStatus,
      selecetdPlayer,
      selectedYear,
      selectedYearExclude,
      testType,
      selectQuestionBank
    );
    setFiltersApplied(true);
    closeModalFilter();
  };

  const [testTypeArray, setTestTypeArray] = useState([]);
  const getTestType = async () => {
    const GetData = await CallWithAuth('GET', GET_TEST_TYPE_LIST);
    if (GetData.status && GetData?.res?.data && Array.isArray(GetData.res.data)) {
      setTestTypeArray(GetData?.res?.data);
    }
  };
  const getTesttypeStyle = () => {
    return {
      color: testType ? 'black' : '#808080',
      width: '347px',
    };
  };
  const getQuestionBankStyle = () => {
    return {
      color: selectQuestionBank ? 'black' : '#808080',
      width: '100%',
    };
  };
  //select year after
  const getYearAfter = () => {
    return {
      color: selectedYear ? 'black' : '#808080',
      width: '210px',
    };
  };
  const getYearBefore = () => {
    return {
      color: selectedYearExclude ? 'black' : '#808080',
      width: '220px',
    };
  };
  const handleTestType = (e) => {
    setTestType(e.target.value);
  };
  const handleQuestionBankChange = (e) => {
    setSelectQuestionBank(e.target.value);
  };

  const handleYearChangeUsed = (e) => {
    setSelectedYear(parseInt(e.target.value, 10));
  };

  const handleYearChangeExclude = (e) => {
    setSelectedYearExclude(parseInt(e.target.value, 10));
  };
  useEffect(() => {
    getQuestionBank();
    getTestType();
  }, []);
  return (
    <div style={{ background: 'rgba(0,0,0,0.1)' }} className={style.filterModal}>
      <div className={style.overlay}></div>
      <div className={` ${style.center_TestFilterdiv} ${style.center_div}`} style={{ height: '97%' }}>
        {/* __________ modal top header __________ */}
        <div className={style.header_top} style={{ height: '10%' }}>
          {/* __________ title __________ */}
          <div className={style.title} style={{ padding: '1.2% 3%' }}>
            <div>
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.39844 2.60156H18.5984C19.6984 2.60156 20.5984 3.50156 20.5984 4.60156V6.80156C20.5984 7.60156 20.0984 8.60156 19.5984 9.10156L15.2984 12.9016C14.6984 13.4016 14.2984 14.4016 14.2984 15.2016V19.5016C14.2984 20.1016 13.8984 20.9016 13.3984 21.2016L11.9984 22.1016C10.6984 22.9016 8.89844 22.0016 8.89844 20.4016V15.1016C8.89844 14.4016 8.49844 13.5016 8.09844 13.0016L4.29844 9.00156C3.79844 8.50156 3.39844 7.60156 3.39844 7.00156V4.70156C3.39844 3.50156 4.29844 2.60156 5.39844 2.60156Z"
                  stroke="#212529"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span> &nbsp; Filter</span>
            </div>
          </div>
          {/* __________ close __________  */}
          <div className={style.close}>
            <button onClick={() => closeModalFilter()}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.34375 6.34375L17.6575 17.6575"
                  stroke="#212529"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.34254 17.6575L17.6562 6.34375"
                  stroke="#212529"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
        {/* __________ modal bottom FIELD __________ */}

        {/* question author  */}

        <div className={style.bottom_Testfields} style={{ height: '70%' }}>
          <div
            className={style.bind}
            style={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingBottom: '0rem' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                width: '40%',
              }}
              className={style.subject}
            >
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative' }}>
                <p className={style.subjectLabel}>Test ID </p>
                <div className={style.search_listing} style={{ margin: '0px', marginBottom: '10px' }}>
                  <div className={style.tag_icons}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="20" height="20" rx="4" fill="#272727" />
                      <path
                        d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                        fill="white"
                      />
                    </svg>
                  </div>

                  <div className={style.input_search}>
                    <div className={style.appear}>
                      <input
                        type="search"
                        id="searchInput"
                        autoComplete="off"
                        onKeyDown={(e) => {
                          // Allow: Backspace, Tab, Arrow keys
                          const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
                          if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder=""
                        value={searchId}
                        onChange={(e) => handleSearchInput(e.target.value)}
                        onBlur={(e) => {
                          if (!onMouseHover) {
                            handleSearchInput('');
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                {isDropdownVisible && matchingIds.length > 0 && (
                  <div
                    onMouseOver={() => {
                      setOnMouseHover(true);
                    }}
                    onMouseLeave={() => {
                      setOnMouseHover(false);
                    }}
                    className={style.list_input_primary}
                    style={{ width: '90%', bottom: 'auto', left: 'auto', top: '100%', height: 'auto' }}
                  >
                    <ul>
                      {matchingIds.map((item) => (
                        <NativeButton
                          onClick={() => {
                            handleSelectId(item);
                            setOnMouseHover(false);
                          }}
                          key={item}
                        >
                          <li style={{ marginBottom: 5 }}>{item}</li>
                        </NativeButton>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className={style.slelectedItemsWrap}>
                {Array.isArray(selectedId) &&
                  selectedId?.map((items, i) => (
                    <div className={style.slelectedItems} key={i}>
                      <span
                        className={style.selected_tags}
                        style={{ height: 'auto', overflowWrap: 'break-word', width: '100%' }}
                      >
                        {items}
                      </span>
                      <button
                        className={style.crossbutton}
                        onKeyDown={(e) => e.key === 'Enter' && removeId(items)}
                        onClick={() => removeId(items)}
                      >
                        <img src={closeIcon} alt="Close" />
                      </button>
                    </div>
                  ))}
              </div>
            </div>
            <div className={style.templateDrop_item} style={{ width: '50%' }}>
              <div className={style.templateGroup}>
                <p className={style.subjectLabel}>Test Type </p>
              </div>
              <div className={style.custom_select}>
                <select
                  style={getTesttypeStyle()}
                  value={testType}
                  onChange={handleTestType}
                  className={`${style.testType_drop_filter}`}
                >
                  <option value="">Select test type</option>
                  {testTypeArray?.map((items, i) => (
                    <option key={i + 1} value={items.id}>
                      {items.test_type}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className={style.tagswrap} style={{ paddingBottom: '0rem' }}>
            <div className={style.subject} style={{ width: '40%' }}>
              <p className={style.subjectLabel}>Test Template </p>
              <div style={{ marginTop: '20px' }} className={style.search_listing}>
                <div className={style.tag_icons}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="20" height="20" rx="4" fill="#272727" />
                    <path
                      d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <div style={{ display: 'flex' }} className={style.input_search}>
                  <div className={style.appear}>
                    <input
                      className={style.bar}
                      type="search"
                      id="searchInput"
                      autoComplete="off"
                      placeholder=""
                      value={playerInput}
                      onChange={handlePlayerInputChange}
                      onBlur={() => {
                        if (!onMouseHover) {
                          setPlayerInput('');
                          setPlayerDropdwon(false);
                        }
                      }}
                    />
                  </div>

                  {playerDropdown && (
                    <div
                      onMouseOver={() => {
                        setOnMouseHover(true);
                      }}
                      onMouseLeave={() => {
                        setOnMouseHover(false);
                      }}
                      className={style.list_input_primary}
                    >
                      <ul>
                        {' '}
                        {player?.map((player) => (
                          <NativeButton
                            onClick={() => {
                              handlePlayerChange(player);
                              setOnMouseHover(false);
                            }}
                            key={player.id}
                          >
                            <li style={{ marginTop: 9 }} value={player}>
                              {player.product_type}
                            </li>
                          </NativeButton>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className={style.slelectedItemsWrap}>
                {selecetdPlayer?.map((items, i) => (
                  <div className={style.slelectedItems} key={i + 1}>
                    <span
                      className={style.selected_tags}
                      style={{ height: 'auto', overflowWrap: 'break-word', width: '100%' }}
                    >
                      {items.product_type}{' '}
                    </span>
                    <button
                      className={style.crossbutton}
                      onKeyDown={(e) => e.key === 'Enter' && removeTestTemplate(items)}
                      onClick={() => removeTestTemplate(items)}
                    >
                      <img src={closeIcon} alt="Close" />
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', width: '42%' }} className={style.subject}>
              <p className={style.subjectLabel}>Status</p>
              <div className={style.search_listing}>
                <div className={style.tag_icons}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="20" height="20" rx="4" fill="#272727" />
                    <path
                      d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <div className={style.input_search}>
                  <div className={style.appear}>
                    <input
                      type="search"
                      id="searchInput"
                      autoComplete="off"
                      placeholder=""
                      value={inputValue}
                      onChange={handleInputChange}
                      onBlur={() => {
                        if (!onMouseHover) {
                          setInputValue('');
                          setFilteredStatus([]);
                          setFilterDropdown(false);
                        }
                      }}
                    />
                  </div>
                  {filterDropdown && (
                    <div
                      onMouseOver={() => {
                        setOnMouseHover(true);
                      }}
                      onMouseLeave={() => {
                        setOnMouseHover(false);
                      }}
                      className={style.list_input_primary}
                    >
                      <ul>
                        {' '}
                        {filteredStatus?.map((name, index) => (
                          <NativeButton
                            onClick={() => {
                              handleSelectionChange(name);
                              setOnMouseHover(false);
                            }}
                            key={index + name}
                          >
                            <li value={name}>{name}</li>
                          </NativeButton>
                        ))}{' '}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className={style.slelectedItemsWrap}>
                {selecteStatus?.map((items, i) => (
                  <div className={style.slelectedItems} key={i + 1}>
                    <span
                      className={style.selected_tags}
                      style={{ height: 'auto', overflowWrap: 'break-word', width: '100%' }}
                    >
                      {items}
                    </span>
                    <button
                      className={style.crossbutton}
                      onKeyDown={(e) => e.key === 'Enter' && removeStatus(items)}
                      onClick={() => removeStatus(items)}
                    >
                      <img src={closeIcon} alt="Close" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={style.tagswrap} style={{ width: '100%', paddingBottom: '0.8rem' }}>
            <div className={style.subject} style={{ width: '40%' }}>
              <p className={style.subjectLabel}>Question Bank</p>
              <div className={style.custom_select} style={{ width: '100%' }}>
                <select
                  className={`${style.question_drop_filter}`}
                  style={getQuestionBankStyle()}
                  value={selectQuestionBank}
                  onChange={handleQuestionBankChange}
                >
                  <option value="">Select question bank</option>
                  {questionBank?.map((items, i) => (
                    <option key={i + 1} value={items.id}>
                      {items.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className={style.subject}>
              <p className={style.subjectLabel}>Include Question Used in or After </p>
              <div className={style.custom_select}>
                <select
                  className={`${style.testType_drop_filter}`}
                  style={getYearAfter()}
                  value={selectedYear}
                  onChange={handleYearChangeUsed}
                >
                  <option value="">Select year</option>
                  {yearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }} className={style.subject}>
              <p className={style.subjectLabel}>Include Question Used in or Before</p>
              <div className={style.custom_select}>
                <select
                  className={`${style.testType_drop_filter}`}
                  style={getYearBefore()}
                  value={selectedYearExclude}
                  onChange={handleYearChangeExclude}
                >
                  <option value="">Select year</option>
                  {yearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className={style.tagswrap}>
            <div className={style.subject} style={{ width: '40%' }}>
              <p className={style.subjectLabel}>Question Author(s) </p>
              <div style={{ marginTop: '20px' }} className={style.search_listing}>
                <div className={style.tag_icons}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="20" height="20" rx="4" fill="#272727" />
                    <path
                      d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <div className={style.input_search}>
                  <input
                    type="search"
                    id="searchInput"
                    placeholder=""
                    value={multiAuthorTaginput}
                    autoComplete="off"
                    onChange={(e) => TagAuthorMultiple(e.target.value)}
                    onBlur={() => {
                      if (!onMouseHover) {
                        TagAuthorMultiple('');
                        setmultiAuthorTag([]);
                        setmultiAuthorTagStatus(false);
                      }
                    }}
                  />

                  {multiAuthorTagStatus ? (
                    <div
                      onMouseOver={() => {
                        setOnMouseHover(true);
                      }}
                      onMouseLeave={() => {
                        setOnMouseHover(false);
                      }}
                      className={style.list_input_primary}
                    >
                      {multiAuthorTag
                        ?.filter((item) => !multiselectedAuthorTag.some((filterItem) => item.id === filterItem.id))
                        .map((items, i) => (
                          <NativeButton
                            key={i + items.first_name}
                            onClick={() => {
                              selectAuthorTag(items);
                              setOnMouseHover(false);
                            }}
                          >
                            <div>
                              <span
                                style={{
                                  wordBreak: 'break-all',
                                  whiteSpace: 'normal',
                                }}
                              >
                                {items.first_name}-{items.last_name}{' '}
                              </span>
                            </div>
                          </NativeButton>
                        ))}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>

              <div className={style.slelectedItemsWrap}>
                {multiselectedAuthorTag?.map((items, i) => (
                  <div className={style.slelectedItems} key={i + 1} style={{ maxWidth: '94%' }}>
                    <span
                      className={style.selected_tags}
                      style={{ height: 'auto', overflowWrap: 'break-word', width: '92%' }}
                    >
                      {items.first_name}-{items.last_name}{' '}
                    </span>
                    <button
                      className={style.crossbutton}
                      onKeyDown={(e) => e.key === 'Enter' && removeAuthor(items)}
                      onClick={() => removeAuthor(items)}
                    >
                      <img src={closeIcon} alt="Close" />
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', width: '42%' }} className={style.subject}>
              <p className={style.subjectLabel}>Free Tags </p>
              <div className={style.search_listing}>
                <div className={style.tag_icons}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="20" height="20" rx="4" fill="#272727" />
                    <path
                      d="M5.64103 10.7693H9.23072V14.359C9.23072 14.7179 9.51278 15 9.87175 15C10.2307 15 10.5128 14.7179 10.5128 14.359V10.7693H14.359C14.7179 10.7693 15 10.4872 15 10.1283C15 9.76928 14.7179 9.48722 14.359 9.48722H10.5128V5.64103C10.5128 5.28206 10.2307 5 9.87175 5C9.51278 5 9.23072 5.28206 9.23072 5.64103V9.48722H5.64103C5.28206 9.48722 5 9.76928 5 10.1283C5 10.4872 5.28206 10.7693 5.64103 10.7693Z"
                      fill="white"
                    />
                  </svg>
                </div>

                <div className={style.input_search}>
                  <input
                    type="search"
                    id="searchInput"
                    placeholder=""
                    value={multiFreeTaginput}
                    autoComplete="off"
                    onChange={(e) => TagFreeMultiple(e.target.value)}
                    onBlur={() => {
                      if (!onMouseHover) {
                        TagFreeMultiple('');
                        setmultiFreeTag([]);
                        setmultiFreeTagStatus(false);
                      }
                    }}
                  />

                  {multiFreeTagStatus ? (
                    <div
                      onMouseOver={() => {
                        setOnMouseHover(true);
                      }}
                      onMouseLeave={() => {
                        setOnMouseHover(false);
                      }}
                      className={style.list_input_primary}
                    >
                      {multiFreeTag
                        ?.filter((item) => !multiselectedFreeTag?.some((filterItem) => item.id === filterItem.id))
                        .map((items, i) => (
                          <NativeButton
                            key={i + items.name}
                            onClick={() => {
                              selectFreeTag(items);
                              setOnMouseHover(false);
                            }}
                          >
                            <div>
                              <span>{items.name} </span>
                            </div>
                          </NativeButton>
                        ))}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className={style.slelectedItemsWrap}>
                {multiselectedFreeTag?.map((items, i) => (
                  <div className={style.slelectedItems} key={i + 1}>
                    <span
                      className={style.selected_tags}
                      style={{ height: 'auto', overflowWrap: 'break-word', width: '100%' }}
                    >
                      {items.name}{' '}
                    </span>
                    <button
                      className={style.crossbutton}
                      onKeyDown={(e) => e.key === 'Enter' && removeFreeTags(items)}
                      onClick={() => removeFreeTags(items)}
                    >
                      <img src={closeIcon} alt="Close" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* __________ apply and save button __________ */}
        <div className={style.apply_buttonWrap}>
          <button onClick={() => handle()} className={style.applyFilter_button}>
            Apply Selected Filter
          </button>
        </div>
      </div>
    </div>
  );
};

TestFilterModal.propTypes = {
  closeModalFilter: PropTypes.func,
  onFilterStateChange: PropTypes.func,
  setFiltersApplied: PropTypes.func,
  multiselectedAuthorTag: PropTypes.func,
  setMultiselectedAuthorTag: PropTypes.func,
  multiselectedFreeTag: PropTypes.func,
  setmultiSelectedFreeTag: PropTypes.func,
  selectedId: PropTypes.func,
  setSelectedId: PropTypes.func,
  selecteStatus: PropTypes.func,
  setSelecteStatus: PropTypes.func,
  selectQuestionBank: PropTypes.func,
  setSelectQuestionBank: PropTypes.func,
  selecetdPlayer: PropTypes.func,
  setSelectedPlayer: PropTypes.func,
  testType: PropTypes.func,
  setTestType: PropTypes.func,
  selectedYearExclude: PropTypes.func,
  setSelectedYearExclude: PropTypes.func,
  selectedYear: PropTypes.func,
  setSelectedYear: PropTypes.func,
};

export default TestFilterModal;
